import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
  },
  textField: {
    minWidth: 180,
    width: '220px',
    margin: 3,
  },
  card: {
    alignItems: 'center',
  },
  button: {
    margin: theme.spacing(1),
    size: 'large',
    width: '8rem',
    height: '2.5rem',
    backgroundColor: '#FFA500',
  },
}));

export default useStyles;
